var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobeBlue = function SvgGlobeBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.565 19.341A13.405 13.405 0 0 0 16.89.528 13.395 13.395 0 0 0 4.785 3.322c-.063.043-.12.094-.172.15a13.4 13.4 0 0 0 9.17 23.43l.008.001h.013a13.423 13.423 0 0 0 11.68-7.398l.001-.003a1.03 1.03 0 0 0 .08-.16Zm-.721-5.841a11.29 11.29 0 0 1-.713 3.958l-5.982-3.678a2.047 2.047 0 0 0-.804-.287l-2.942-.397a2.076 2.076 0 0 0-1.975.878h-1.101l-.49-1.013a2.063 2.063 0 0 0-1.424-1.118l-.846-.182.324-.77a1.032 1.032 0 0 1 .95-.631h2.068c.348 0 .691-.089.997-.257l1.578-.872c.139-.076.268-.169.386-.275l3.469-3.138a2.05 2.05 0 0 0 .572-2.186 11.353 11.353 0 0 1 5.933 9.968Zm-22.688 0a11.275 11.275 0 0 1 1.22-5.113l1.343 3.586a2.053 2.053 0 0 0 1.498 1.293l.711.152.006.002 1.554.334a1.031 1.031 0 0 1 .711.559l.271.56a2.062 2.062 0 0 0 1.857 1.164h.143l-.992 2.226a2.06 2.06 0 0 0 .37 2.24l2.068 2.237a1.032 1.032 0 0 1 .256.896l-.231 1.194A11.358 11.358 0 0 1 2.156 13.5Z",
    fill: "#1E73FF"
  })));
};

export default SvgGlobeBlue;